var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-item",
    on: {
      "click": _vm.onItemClick
    }
  }, [_c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "subtitle-info"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n      订单编号\n      "), _c('span', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.order.order_no),
      expression: "order.order_no",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopied),
      expression: "onCopied",
      arg: "success"
    }]
  }, [_vm._v("\n        " + _vm._s(_vm.order.order_no) + "\n        "), (_vm.isSearching) ? _c('i', {
    staticClass: "pay-state"
  }, [_vm._v(_vm._s(_vm.isSearching))]) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v("\n      订单状态\n      "), _c('span', {
    class: _vm.statusClass
  }, [_vm._v(_vm._s(_vm.order.order_status_title))]), _vm._v(" "), _c('span', {
    class: {
      'ic-arrow-yellow': _vm.order.need_action
    }
  })])]), _vm._v(" "), (_vm.isStaff) ? _c('div', {
    staticClass: "info-cont"
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.create_time))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓      名")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.customer_name))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("套餐名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.product_pkg_title))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("购买价格")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.pay_price) + "元")])]), _vm._v(" "), (this.order.is_delete) ? _c('div', {
    staticClass: "mt-5 top-dashed-line center-t",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toDelete($event)
      }
    }
  }, [_vm._m(0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isCustomer) ? _c('div', {
    staticClass: "info-cont"
  }, [_c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("套餐名称")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.product_pkg_title))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "label"
  }, [_vm._v("购买价格")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.pay_price) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!this.order.has_signed),
      expression: "!this.order.has_signed"
    }]
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务时长")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.service_period) + "个月")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.order.has_signed),
      expression: "this.order.has_signed"
    }]
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("服务时间")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.order.service_start_date) + " 至 " + _vm._s(_vm.order.service_end_date))])])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticClass: "delete-red",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("删除")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-505913ca","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderItem.vue
// module id = 240
// module chunks = 0